import React from "react";
import moment from "moment";
import { selectFormat } from "./../Utils.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

const formatText = (tooltip_data) => {
  const previous_date = moment(tooltip_data.previous_date);
  const current_date = moment(tooltip_data.current_date);

  const diff = current_date.diff(previous_date, "days");

  return diff
    ? diff + " day" + (diff > 1 ? "s" : "") + " prior"
    : "No days prior";
};

export const XrayTooltipSharedLineChart = (props) => {
  const { data, close } = props;
  const extra = data.hasSharedLineChart;

  return (
    <div>
      <XRayTooltipHeader
        date={selectFormat("date", data.activeLabel, "ddd, MMMM DD")}
        close={close}
      />

      <main className="standard-tooltip__main">
        <div className="standard-tooltip__item">
          <span className="standard-tooltip__key">
            <span
              className="standard-tooltip__icon"
              style={{ background: extra.color }}
            />
            This day
          </span>
          <span className="standard-tooltip__value">
            {selectFormat("number", extra.today)}
          </span>
        </div>

        <div className="standard-tooltip__item">
          <span className="standard-tooltip__key">
            <span
              className="standard-tooltip__icon"
              style={{
                background: extra.color,
                opacity: 0.2,
              }}
            />
            {formatText(extra)}
          </span>
          <span className="standard-tooltip__value">
            {selectFormat("number", extra.yesterday)}
          </span>
        </div>
      </main>
    </div>
  );
};
